import styled from 'styled-components';
const SliderBlogWrapper = styled.div`    
    .blog-cover {
        img {
            width: 100%;
            object-fit: cover;
            height: 350px;
            border-radius: 6px;
        }
    }
`;

export default SliderBlogWrapper